import React from "react";
import "./App.css";
import Cart from "./components/Cart";
import Details from "./components/Details";
import Header from "./components/Header";
import NotFound from "./components/NotFound";
import ProductList from "./components/ProductList";
import "./styles/styles.scss";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Shop from "./components/Shop";
import OptionModal from "./components/OptionModal";

const App = () => {
  return (
    <>
      <Router>
        <Header />
        <Switch>
          <Route exact path="/" component={ProductList} />
          <Route exact path="/details" component={Details} />
          <Route exact path="/shop" component={Shop} />
          <Route exact path="/cart" component={Cart} />
          <Route component={NotFound} />
        </Switch>
        <OptionModal />
      </Router>
    </>
  );
};

export default App;
